<template>
  <div class="labs-mixes">
    <div class="ui container">

      <div class="ui breadcrumb" style="margin: 20px 0 10px 0;">
        <router-link to="/" class="section">Home</router-link>
        <i class="right chevron icon divider"></i>
        <router-link to="/labs" class="section">Labs</router-link>
        <i class="right chevron icon divider"></i>
        <div class="active section">Mixes</div>
      </div>

      <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:20px;">
        <h2 class="ui header" style="margin:0;">
          <i class="tint icon"></i>
          <div class="content">Mixes</div>
        </h2>
        <div style="display:flex; align-items:center; gap:10px;">
          <div class="ui input">
            <input type="text" placeholder="Search mixes..." v-model="search" />
          </div>
          <button v-if="isAdmin" class="ui green button" @click="addNewMix">
            <i class="plus icon"></i> Add Test Data
          </button>
        </div>
      </div>

      <div v-if="loading" class="ui active centered inline loader"></div>

      <div v-else-if="error" class="ui negative message">
        <i class="close icon" @click="error = null"></i>
        <p>{{ error }}</p>
      </div>

      <div v-else-if="filteredMixes.length === 0" class="ui info message">
        <p>No mix records found.</p>
      </div>

      <div v-else>
        <table class="ui celled striped table">
          <thead>
            <tr>
              <th v-if="isAdmin" style="width:50px;">Visible</th>
              <th>Test Number</th>
              <th>Date</th>
              <th>WBM Target %</th>
              <th>WBM Measured %</th>
              <th>Total Weight (g)</th>
              <th>Mixer Type</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="mix in filteredMixes" :key="mix.id"
                :style="isAdmin && !mix.visibleToCustomer ? 'opacity:0.55' : ''">
              <td v-if="isAdmin" style="text-align:center;">
                <input
                  type="checkbox"
                  :checked="mix.visibleToCustomer"
                  @change="toggleVisibility(mix)"
                  title="Visible to customer"
                />
              </td>
              <td>{{ mix.testNumber || '—' }}</td>
              <td>{{ formatDate(mix.mixDate) }}</td>
              <td>{{ mix.mixWbmTargetPct != null ? mix.mixWbmTargetPct + '%' : '—' }}</td>
              <td>{{ mix.mixWbmMeasuredPct != null ? mix.mixWbmMeasuredPct + '%' : '—' }}</td>
              <td>{{ mix.totalMixWeightDryG != null ? mix.totalMixWeightDryG.toLocaleString() : '—' }}</td>
              <td>{{ mix.mixerType || '—' }}</td>
              <td>
                <router-link :to="'/labs/mixes/' + mix.id" class="ui mini primary button">
                  {{ isAdmin ? 'Edit' : 'View' }}
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import httpClient from "@/assets/js/HttpClient";

export default {
  name: "LabsMixes",
  data() {
    return {
      mixes: [],
      search: "",
      loading: true,
      error: null,
    };
  },
  computed: {
    ...mapGetters({ currentUser: "currentUser" }),
    isAdmin() {
      return this.currentUser && this.currentUser.admin;
    },
    filteredMixes() {
      let list = this.mixes;
      if (!this.isAdmin) {
        list = list.filter((m) => m.visibleToCustomer !== false);
      }
      if (!this.search) return list;
      const term = this.search.toLowerCase();
      return list.filter(
        (m) =>
          (m.testNumber && m.testNumber.toLowerCase().includes(term)) ||
          (m.mixerType && m.mixerType.toLowerCase().includes(term))
      );
    },
  },
  methods: {
    formatDate(val) {
      if (!val) return "—";
      return new Date(val).toLocaleDateString();
    },
    async loadMixes() {
      try {
        const response = await httpClient.get("/labs/mixes");
        this.mixes = response.data;
      } catch (err) {
        this.error = "Unable to load mixes. Please try again.";
      } finally {
        this.loading = false;
      }
    },
    async addNewMix() {
      try {
        const response = await httpClient.post("/labs/mixes", {});
        if (response.data && response.data.id) {
          this.$router.push("/labs/mixes/" + response.data.id);
        } else {
          await this.loadMixes();
        }
      } catch (err) {
        this.error = "Unable to create new mix. Please try again.";
      }
    },
    async toggleVisibility(mix) {
      const newVal = !mix.visibleToCustomer;
      try {
        await httpClient.patch("/labs/mixes/" + mix.id + "/visibility", {
          visible: newVal,
        });
        mix.visibleToCustomer = newVal;
      } catch (err) {
        this.error = "Unable to update visibility. Please try again.";
      }
    },
  },
  mounted() {
    this.loadMixes();
  },
};
</script>
